import script from "./TierController.vue?vue&type=script&setup=true&lang=js"
export * from "./TierController.vue?vue&type=script&setup=true&lang=js"

import "./TierController.vue?vue&type=style&index=0&id=4a8ec035&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a8ec035"]])

export default __exports__